var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 598,
    viewBox: "0 0 582 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5757 366.187C9.12354 360.105 9.12354 354.269 12.5757 348.68L71.7554 245.608C75.2075 239.855 80.2214 236.978 86.7969 236.978H134.88C137.017 236.978 138.661 237.964 139.812 239.937C140.963 241.91 140.963 243.8 139.812 245.608L75.7007 357.064L139.812 475.423C140.963 477.396 140.963 479.45 139.812 481.587C138.826 483.56 137.182 484.546 134.88 484.546H86.7969C80.2214 484.546 75.2075 481.505 71.7554 475.423L12.5757 366.187Z",
    fill: "#EA2121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M495.591 125.978C502.331 125.978 507.427 128.855 510.879 134.608L569.812 237.68C573.264 243.269 573.264 249.105 569.812 255.187L510.879 364.423C507.427 370.505 502.331 373.546 495.591 373.546H447.754C445.452 373.546 443.726 372.56 442.576 370.587C441.425 368.45 441.425 366.396 442.576 364.423L506.687 246.064L442.576 134.608C441.425 132.965 441.425 131.156 442.576 129.184C443.726 127.047 445.452 125.978 447.754 125.978H495.591Z",
    fill: "#EA2121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.221 354.934L363.636 3.46339C363.636 3.46339 350.309 39.1872 335.207 83.616C311.714 152.727 283.51 243.28 295.311 252.44C307.111 261.601 333.57 276.051 378.892 260.111L138.221 354.934Z",
    fill: "#EA2121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.04 20.1262C349.505 39.8278 343.301 58.0157 338.216 74.7641C344.336 57.1737 350.69 38.8784 357.04 20.1262Z",
    fill: "#600202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.553 240.4C291.576 232.937 301.968 194.156 338.216 74.7641C310.36 154.834 287.368 220.3 291.792 247.785C301.725 282.635 356.336 275.087 445.566 233.132L411.732 240.513C411.732 240.513 353.53 247.863 322.553 240.4Z",
    fill: "#600202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.779 243.477L221.363 594.948C221.363 594.948 234.69 559.224 249.793 514.795C273.286 445.685 301.489 355.131 289.689 345.971C277.888 336.811 251.43 322.36 206.107 338.301L446.779 243.477Z",
    fill: "#EB2121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.958 579.231C235.494 559.345 241.697 540.987 246.783 524.082C240.663 541.837 234.308 560.304 227.958 579.231Z",
    fill: "#600202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.448 356.899C293.425 364.431 283.032 403.575 246.783 524.082C274.639 443.264 297.633 377.186 293.208 349.444C283.276 314.268 228.665 321.887 139.435 364.236L173.269 356.786C173.269 356.786 231.471 349.366 262.448 356.899Z",
    fill: "#600202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c0e122e239aa9b97411e745a057fc03.svg";
export { ForwardRef as ReactComponent };